let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ReQi1")).then(() => parcelRequire('3UXio'));